const pathToUrl = (path) => {
  return encodeURI(
    process.env.REACT_APP_BACKEND_URL + "/" + path?.replaceAll("\\", "/")
  );
};

export default pathToUrl;
